"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _exception = require("../exception");
var URL = /*#__PURE__*/(0, _createClass2["default"])(function URL() {
  (0, _classCallCheck2["default"])(this, URL);
});
URL.SERVER = 'api.php';
URL.ENROLL = 'enroll.php';
URL.TRANLIST = 'trnslist.php';
URL.EXPORTTRAN = 'export.php';
URL.GETCODE = 'getuid.php';
URL.GETADDRESS = 'getadd.php';
URL.KEYSTORE = 'keys.php';
URL.requestMessages = 'requestMessages.php';
var AjaxReqAbstract = /*#__PURE__*/function () {
  function AjaxReqAbstract() {
    (0, _classCallCheck2["default"])(this, AjaxReqAbstract);
    this.pendingPosts = [];
  }
  //
  // URL.SERVER POST requests (that are using queuing mecanism)
  //
  (0, _createClass2["default"])(AjaxReqAbstract, [{
    key: "post",
    value: function post(data) {
      var self = this;
      return new Promise(function (resolve, reject) {
        self.pendingPosts.push({
          data: data,
          resolve: resolve,
          reject: reject
        });
        if (self.pendingPosts.length === 1) self.queuePost();
      });
    }
  }, {
    key: "queuePost",
    value: function queuePost() {
      var _this$pendingPosts$ = this.pendingPosts[0],
        data = _this$pendingPosts$.data,
        resolve = _this$pendingPosts$.resolve,
        reject = _this$pendingPosts$.reject;
      this.endpoint.post(URL.SERVER, data).then(function (res) {
        if (res.error) {
          reject(new _exception.APIError(res.msg, res.data));
          return;
        }
        resolve(res.data);
      });
      this.pendingPosts.splice(0, 1);
      if (this.pendingPosts.length > 0) {
        this.queuePost();
      }
    }
  }, {
    key: "getBalance",
    value: function getBalance(addr) {
      return this.post({
        balance: addr
      });
    }
  }, {
    key: "getTransactionData",
    value: function getTransactionData(addr) {
      return this.post({
        txdata: addr
      });
    }
  }, {
    key: "sendTx",
    value: function sendTx(rawTx, more) {
      return this.post(Object.assign({
        rawtx: rawTx
      }, more !== null && more !== void 0 ? more : {}));
    }
  }, {
    key: "getEthCall",
    value: function getEthCall(txobj) {
      return this.post({
        ethCall: txobj
      });
    }
  }, {
    key: "getEthCallAt",
    value: function getEthCallAt(txobj, blockNb) {
      return this.post({
        ethCallAt: txobj,
        blockNb: blockNb
      });
    }
    //
    // Other calls
    //
  }, {
    key: "enrollPost",
    value: function enrollPost(data) {
      return this.endpoint.post(URL.ENROLL, {
        data: JSON.stringify(data)
      });
    }
  }, {
    key: "getTransList",
    value: function () {
      var _getTransList = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(id, count, offset) {
        var data;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.endpoint.get(URL.TRANLIST, {
                addr: id,
                count: count,
                offset: offset
              });
            case 2:
              data = _context.sent;
              return _context.abrupt("return", data.map(function (dataJSON) {
                return JSON.parse(dataJSON);
              }));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTransList(_x, _x2, _x3) {
        return _getTransList.apply(this, arguments);
      }
      return getTransList;
    }()
  }, {
    key: "getExportTransList",
    value: function () {
      var _getExportTransList = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(id, start, end) {
        var data;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.endpoint.get(URL.EXPORTTRAN, {
                addr: id,
                start: start,
                end: end
              });
            case 2:
              data = _context2.sent;
              return _context2.abrupt("return", data.map(function (dataJSON) {
                return JSON.parse(dataJSON);
              }));
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getExportTransList(_x4, _x5, _x6) {
        return _getExportTransList.apply(this, arguments);
      }
      return getExportTransList;
    }()
  }, {
    key: "getCodesFromAddresses",
    value: function getCodesFromAddresses(addresses, currency, caller, signature) {
      return this.endpoint.post(URL.GETCODE, {
        server: currency,
        caller: caller,
        signature: signature,
        addresses: addresses
      });
    }
  }, {
    key: "getAddressesFromCode",
    value: function getAddressesFromCode(code, currency, caller, signature) {
      return this.endpoint.post(URL.GETADDRESS, {
        server: currency,
        caller: caller,
        signature: signature,
        code: code
      });
    }
  }, {
    key: "getMessageKey",
    value: function getMessageKey(addr, withPrivate) {
      var data = {
        addr: addr
      };
      if (withPrivate) data["private"] = '1';
      return this.endpoint.get(URL.KEYSTORE, data);
    }
  }, {
    key: "publishMessageKey",
    value: function publishMessageKey(data, sign) {
      return this.endpoint.post(URL.KEYSTORE, {
        data: data,
        sign: sign
      });
    }
  }, {
    key: "requestUnlock",
    value: function requestUnlock(address, url) {
      return this.endpoint.post(url, {
        address: address
      });
    }
  }, {
    key: "getReqMessages",
    value: function getReqMessages(addFrom, addTo) {
      return this.endpoint.get(URL.requestMessages, {
        add_req: addFrom,
        add_cli: addTo
      });
    }
  }, {
    key: "publishReqMessages",
    value: function publishReqMessages(data, sign) {
      return this.endpoint.post(URL.requestMessages, {
        data: data,
        sign: sign
      });
    }
  }, {
    key: "currBlock",
    value: function currBlock() {
      return this.endpoint.get(URL.SERVER);
    }
  }, {
    key: "getBlock",
    value: function () {
      var _getBlock = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(hash) {
        var res;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.endpoint.get(URL.SERVER, {
                hash: hash
              });
            case 2:
              res = _context3.sent;
              if (res && (0, _typeof2["default"])(res) !== 'object') {
                res = JSON.parse(res).transaction;
              }
              return _context3.abrupt("return", res);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getBlock(_x7) {
        return _getBlock.apply(this, arguments);
      }
      return getBlock;
    }()
  }]);
  return AjaxReqAbstract;
}();
exports["default"] = AjaxReqAbstract;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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